import { IContacts } from "../domain/models/Contacts";
import { BaseModelImpl } from "./BaseModelImpl";

export class ContactsModel extends BaseModelImpl<IContacts> implements IContacts {
    id: string;
    address: string;
    phone: string;
    email: string;
    directorId?: string;
    creatorId: string;
    createdAt?: Date;
    updatedAt?: Date;

    constructor(data?: IContacts) {
        super();
        this.assignData(data);
    }
}

